import * as React from 'react';
import {
  ScrollView,
  StyleSheet,
  Text,
  TextStyle,
  View,
  ViewStyle,
} from 'react-native';

import PrimaryButton from '../../../../shared/buttons/PrimaryButton';
import SvgUriAdapter from '../../../../shared/svg/SvgUriAdapter';
import CheckButton from '../../../../shared/forms/CheckButton';

interface Props {
  onPress: () => void;
}

const ServiceExplanationStep3: React.FC<Props> = props => {
  const {onPress} = props;
  const [checked, setChecked] = React.useState(false);
  const onPressCheck = React.useCallback(() => {
    setChecked(!checked);
  }, [checked]);
  return (
    <ScrollView>
      <View style={styles.container}>
        <Text style={styles.message}>
          契約周りや、報酬のお支払いの窓口は{'\n'}
          すべて当社が行います。{'\n'}
          オファーに向けた作品作りに集中いただけます。
        </Text>
        <Text style={styles.note}>
          ※お支払いはTapNovelMakerのポイントでのお支払いとなります。
        </Text>
        <CheckButton
          style={styles.checkButton}
          checked={checked}
          onPress={onPressCheck}>
          理解した
        </CheckButton>
        <PrimaryButton disabled={!checked} onPress={onPress}>
          次へ
        </PrimaryButton>
      </View>
    </ScrollView>
  );
};

export default React.memo(ServiceExplanationStep3);

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#fff',
    borderTopColor: '#efefef',
    borderTopWidth: 1,
    flex: 1,
    alignItems: 'center',
    padding: 24,
  } as ViewStyle,
  message: {
    color: '#383838',
    fontSize: 14,
    textAlign: 'center',
    marginVertical: 8,
  } as TextStyle,
  note: {
    color: '#666',
    fontSize: 11,
    textAlign: 'center',
    marginVertical: 8,
  } as TextStyle,
  checkButton: {
    width: 160,
    justifyContent: 'center',
    marginTop: 24,
    marginBottom: 16,
  } as ViewStyle,
});
